export function setChangeScreen(estado) {
  return {
    type: 'SET_CHANGE_SCREEN',
    estado,
  };
}
